<template >
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="6">
          <h6 class="m-0">Informações do orçamento</h6>
        </d-col>
        <d-col cols="12" md="6" class="text-right">
          <quotation-buttons :quotation="model"></quotation-buttons>
        </d-col>
      </d-row>
    </d-card-header>

    <d-card-body class="d-flex flex-column">
      <d-form @submit.prevent="">
        <d-form-row>

          <!-- Budget number -->
          <d-col lg="6" xl="2" cols="12" class="form-group">
            <label for="feShippingCOmpany">Orçamento nº</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.reference_no" readonly/>
          </d-col>

          <!-- Customer -->
          <d-col lg="6" xl="6" cols="12" class="form-group">
            <label for="feShippingCOmpany">Cliente</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.customer_name" readonly/>
          </d-col>

          <!-- Customer City -->
          <d-col lg="6" xl="2" cols="12" class="form-group">
            <label for="feShippingCOmpany">Cidade</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.customer_city" readonly/>
          </d-col>

          <!-- Customer  State-->
          <d-col lg="6" xl="2" cols="12" class="form-group">
            <label for="feShippingCOmpany">Estado</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.customer_state" readonly/>
          </d-col>

        </d-form-row>

        <d-form-row>

          <!-- Valid at -->
          <d-col :md="model.approved_by ? '4' : '3'" lg="2" class="form-group">
            <label>Validade</label>
            <datepicker :model.sync="model.valid_at"/>
          </d-col>

          <!-- Seller -->
          <d-col md="4" lg="2" class="form-group">
            <label>Vendedor</label>
            <autocomplete
              ref="autocomplete_seller"
              placeholder="Vendedor"
              :items="users"
              item-show="name"
              :on-input="onInput"
              :on-select="setSeller"
              :on-show-text="showText"
              v-if="isAdmin"
            />
            <d-form-input type="text" v-model="model.created_user.name" readonly v-else/>
          </d-col>

          <!-- Approved by -->
          <d-col v-if="model.approved_by" md="4" lg="2" class="form-group">
            <label>Aprovado por</label>
            <label class="form-control">{{ model.approved_user.name }}</label>
          </d-col>

          <!-- Project Size -->
          <ProjectMeasure :model="model" disabled />

          <d-col :md="model.approved_by ? '6' : '12'" :lg="model.approved_by ? '3' : '5'" cols="12" class="form-group">
            <!-- Show payment -->
            <d-form-row :class="model.approved_by ? 'justify-content-md-end' : 'justify-content-lg-end'" class="mb-1">
              <label class="mr-3 text-md-right">Exibir formas de pagamento</label>
              <d-checkbox toggle @change="toggleShowPayment()" :checked="showPayment" class="custom-toggle-sm mr-2">Sim</d-checkbox>
            </d-form-row>
            <!-- Show classes -->
            <d-form-row :class="model.approved_by ? 'justify-content-md-end' : 'justify-content-lg-end'" class="mb-1">
              <label class="mr-3 text-md-right">Exibir classes</label>
              <d-checkbox toggle @change="toggleShowClasses()" :checked="show_classes" class="custom-toggle-sm mr-2">Sim</d-checkbox>
            </d-form-row>
            <!-- Items included in two columns -->
            <d-form-row :class="model.approved_by ? 'justify-content-md-end' : 'justify-content-lg-end'">
              <label class="mr-3 text-md-right">Exibir itens inclusos em duas colunas</label>
              <d-checkbox toggle @change="toggleItemsIncludedTwoColumns()" :checked="itemsIncludedTwoColumns" class="custom-toggle-sm mr-2">Sim</d-checkbox>
            </d-form-row>
          </d-col>

          <!-- Show classes -->
          <d-col cols="12" class="form-group" v-if="show_classes">
            <d-form-row class="justify-content-end">
              <d-col cols="3" class="form-group" v-for="(col, id) in classes" :key="id">
                <label>{{ col.name }}</label>
                <d-select v-model="model.show_classes[id].pricing">
                  <option :value="null">Selecione...</option>
                  <option :value="option" v-for="(option, index) in col.pricing" :key="index">{{ option.mm }}mm</option>
                </d-select>
              </d-col>
            </d-form-row>
          </d-col>

        </d-form-row>

        <d-form-row class="align-items-center">
          <!-- Template -->
          <d-col cols="12" lg="4" class="form-group">
            <autocomplete
              ref="autocomplete_template"
              placeholder="Buscar template..."
              :items="templates"
              item-show="name"
              :on-input="onInputTemplate"
              :on-select="setTemplate"
            />
          </d-col>

          <d-col cols="12" lg="8" class="form-group d-flex flex-wrap">
            <d-button class="btn btn-md btn-primary" @click.prevent="applyQuotationTemplate" :disabled="!selectedTemplateId">
              Aplicar template
            </d-button>
            <d-button class="btn btn-md btn-outline-primary ml-3" @click.prevent="openCreateTemplateModal">
              Transformar em template
            </d-button>
          </d-col>
        </d-form-row>

        <!-- Groups-->
        <d-form-row>
          <d-col cols="12" class="form-group" v-if="model.groups">
            <groups-form ref="group" :groups.sync="model.groups" :state="groupsEmptyRow ? 'invalid' : 'valid' "/>
          </d-col>
        </d-form-row>

        <d-form-row>

          <!-- Companies -->
          <d-col md="6" class="form-group">
            <label>Empresa selecionada</label>
            <d-select
              class="form-control"
              v-model="model.company"
              text-field="label"
              value-field="data"
              :options="companies"
              @change="setCompany"
            >
            </d-select>
          </d-col>

          <!-- Company -->
          <d-col md="12" class="form-group" v-if="model.company_information">
            <editor :model.sync="model.company_information"/>
          </d-col>

        </d-form-row>

        <d-form-row>

          <!-- Signature -->
          <d-col md="3" class="form-group" v-for="(type, index) in signature" :key="type">
            <label>Assinatura: <small>{{type}}</small></label>
            <d-form-input type="text" :placeholder="type" v-model="model.signature[index]"/>
          </d-col>

        </d-form-row>

        <d-form-row>
          <d-col class="d-flex justify-content-end">
            <button class="btn btn-success" @click="save">Salvar</button>
            <button class="btn btn-success ml-4" @click="nextStep">Salvar e avançar</button>
          </d-col>
        </d-form-row>

      </d-form>
      <contractual-items-select-modal/>
      <single-option-select-modal/>
      <import-modals/>
      <modal-template
        title="Transformar em template"
        type-modal="create_quotation_template_modal"
      >
        <div class="modal-content__main">
          <d-form @submit.prevent="createTemplateFromQuotation">
            <d-form-row>
              <d-col cols="12" class="form-group mb-0">
                <label>Nome do template</label>
                <d-form-input
                  :state="templateNameState"
                  type="text"
                  placeholder="Nome do template"
                  v-model="templateForm.name"
                />
                <d-form-invalid-feedback>Nome do template é obrigatório</d-form-invalid-feedback>
              </d-col>
            </d-form-row>
          </d-form>
        </div>

        <div slot="actions" class="modal-content__control">
          <d-button type="button" class="btn btn-sm btn-secondary mr-2" @click="closeCreateTemplateModal">Cancelar</d-button>
          <d-button type="button" class="btn btn-sm btn-success" @click="createTemplateFromQuotation">Salvar</d-button>
        </div>
      </modal-template>
    </d-card-body>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import GroupsForm from '_modules/quotation/components/GroupsForm.vue';
import Datepicker from '_shared/Datepicker.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import ContractualItemsSelectModal from '_modules/quotation/components/modal/ContractualItemsSelectModal.vue';
import SingleOptionSelectModal from '_modules/quotation/components/modal/SingleOptionSelectModal.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinValidateForm from '_common/mixins/ValidateForm';
import ModalTemplate from '_shared/Modal.vue';
import { cloneDeep, getDateTimeISO } from '_utils';
import QuotationActions from './QuotationActions';
import { CLASSES, PRICES } from '../../settings/components/SettingsModel';
import {
  ROW,
  MODEL,
  GROUP,
  SERVICE,
  SIGNATURE,
  _LOAD_MODEL_,
} from './QuotationModel';
import ProjectMeasure from './ProjectMeasure.vue';

export default {
  name: 'step-quotation-form',
  mixins: [MixinValidateForm, QuotationActions],
  components: {
    Editor,
    GroupsForm,
    Datepicker,
    ImportModals,
    QuotationButtons,
    ContractualItemsSelectModal,
    SingleOptionSelectModal,
    Autocomplete,
    ProjectMeasure,
    ModalTemplate,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      items: [],
      show_classes: false,
      loading: false,
      signature: { ...SIGNATURE },
      selectedRowIndex: 0,
      selectedTemplateId: null,
      groupsEmptyRow: null,
      templateModalSubmitted: false,
      templateForm: {
        name: '',
      },
      errors: {},
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    showPayment() {
      return this.model.show_payments === 1;
    },
    itemsIncludedTwoColumns() {
      return !!this.model.items_included_two_columns;
    },
    companies: {
      get() {
        const { company } = this.$store.state.settings;
        if (company && company.informations.length) {
          return company.informations;
        }
        return [];
      },
      set(value) {
        return value;
      },
    },
    classes() {
      const { settings } = this.$store.state.settings;
      if (settings.quotationClass && settings.quotationClass.length) {
        return settings.quotationClass;
      }
      return { ...CLASSES.quotationClass };
    },
    templates() {
      const { templateList } = this.$store.state.quotation;
      if (templateList && templateList.list.length) {
        return templateList.list;
      }
      return [];
    },
    users() {
      const { userList } = this.$store.state.user;
      if (userList && userList.list.length) {
        return userList.list;
      }
      return [];
    },
    templateNameState() {
      if (!this.templateModalSubmitted) {
        return null;
      }
      return this.templateForm.name ? 'valid' : 'invalid';
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
      'activeAlert',
      'getSettings',
      'getTemplateList',
      'getQuotationTemplate',
      'getPaymentTypeOptions',
      'getStaffList',
    ]),
    getQuotationId() {
      const routeId = parseInt(this.$route.params.quotationId, 10);
      return this.model.id || routeId || null;
    },
    reorder(group) {
      group.rows.forEach((row, index) => {
        row.order = index;
        return row;
      });
    },
    cleanEmptyRows() {
      this.groupsEmptyRow = false;
      this.model.groups = this.model.groups.map(group => {
        group.rows = group.rows.filter(row => row.description);
        this.reorder(group);
        if (group.rows.length === 0) {
          this.groupsEmptyRow = true;
          group.rows.push(cloneDeep(ROW));
        }
        return group;
      });
    },
    formatDate() {
      this.model.valid_at = getDateTimeISO(this.model.valid_at);
      this.model.started_date = getDateTimeISO(this.model.started_date);
      this.model.delivery_date = getDateTimeISO(this.model.delivery_date);
    },
    getCompanies() {
      if (!this.$store.state.settings.companies) {
        this.setToggle({ type: 'progress', bool: true });
        this.getSettings()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          })
          .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }));
      }
    },
    nextStep() {
      if (this.save()) {
        this.$router.push({ name: 'admin-quotation-project', params: { quotationId: this.model.id } });
      }
    },
    resetCreateTemplateModal() {
      this.templateModalSubmitted = false;
      this.templateForm = {
        name: '',
      };
    },
    closeCreateTemplateModal() {
      this.resetCreateTemplateModal();
      this.setToggle({ type: 'create_quotation_template_modal', bool: false });
    },
    openCreateTemplateModal() {
      if (!this.getQuotationId()) {
        this.activeAlert({ message: 'Salve o orçamento antes de transformar em template', theme: 'danger' });
        return;
      }

      this.resetCreateTemplateModal();
      this.templateForm.name = this.model.model_name || '';
      this.setToggle({ type: 'create_quotation_template_modal', bool: true });
    },
    createTemplateFromQuotation() {
      this.templateModalSubmitted = true;

      if (!this.templateForm.name) {
        return;
      }

      this.setToggle({ type: 'progress', bool: true });
      QuotationService.createTemplateFromQuotation(this.getQuotationId(), this.templateForm)
        .then(() => {
          this.closeCreateTemplateModal();
          this.activeAlert({ message: 'Template criado com sucesso', theme: 'success' });
          if (this.model.type_id) {
            this.searchTemplates('');
          }
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    save() {
      this.cleanEmptyRows();
      // const valid = this.$refs.group.checkRequiredFields();
      if (this.checkForm()) {
        this.formatDate();
        this.toggleLoading();
        this.model.step = 'quotation';
        return QuotationService.save(this.model)
          .then(response => this.success(response))
          .catch(error => {
            this.toggleLoading();
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
            return false;
          });
      }
      window.scrollTo(0, 0);
      this.activeAlert({ message: 'Erro de validação', theme: 'danger' });
      return false;
    },
    applyQuotationTemplate() {
      this.getQuotationTemplate(this.selectedTemplateId)
        .then(() => {
          this.$refs.group.recalculateAfterTemplateApply();
          window.scrollTo(0, 0);
        })
        .catch(error => {
          const message = error && error.message
            ? error.message
            : 'Erro ao aplicar template';

          this.activeAlert({ message, theme: 'danger' });
        });
    },
    searchTemplates(name = '') {
      if (!this.model.type_id) {
        return;
      }

      this.getTemplateList({
        typeId: this.model.type_id,
        search: name,
        take: 10,
        page: 1,
        skip: 0,
      });
    },
    onInputTemplate(name) {
      this.selectedTemplateId = null;
      clearTimeout(this.templateSearchTimeoutId);
      this.templateSearchTimeoutId = setTimeout(() => {
        this.searchTemplates(name);
      }, 500);
    },
    setTemplate(template) {
      this.selectedTemplateId = template && template.id ? template.id : null;
    },
    setCompany(value) {
      setTimeout(() => {
        this.model.company_information = value;
      }, 10);
    },
    success(quotation) {
      this.toggleLoading();
      this.activeAlert({ message: 'Orçamento salvo com sucesso', theme: 'success' });
      this.model = quotation;
      Events.$emit(_LOAD_MODEL_, quotation);
      this.$store.commit('setQuotation', quotation);
      return true;
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    loadModel(quotation) {
      if (quotation) {
        this.model = quotation;
      }
      if (this.model.type_id) {
        this.searchTemplates('');
      }
      if (this.model.model) {
        this.errors.model_name = { required: (this.model.model) };
        delete this.errors.customer_name;
      }
      if (!this.model.groups) {
        this.model.groups = cloneDeep(GROUP);
      }
      this.$refs.group.setObjectErrors();
      if (!this.model.signature) {
        this.model.signature = cloneDeep(SIGNATURE);
      }
      if (!this.model.service) {
        this.model.service = cloneDeep(SERVICE);
      }
      this.show_classes = this.model.show_classes !== null;
      this.$set(this.model, 'items_included_two_columns', !!this.model.items_included_two_columns);
      this.setAutocompleteSeller(this.model.created_user);
    },
    toggleShowPayment() {
      this.model.show_payments = (this.model.show_payments === 1) ? 0 : 1;
    },
    toggleItemsIncludedTwoColumns() {
      this.model.items_included_two_columns = !this.itemsIncludedTwoColumns;
    },
    toggleShowClasses() {
      this.show_classes = !this.show_classes;
      if (this.show_classes && this.model.show_classes === null) {
        this.model.show_classes = cloneDeep(this.classes);
        this.model.show_classes.map(item => {
          item.pricing = { ...PRICES };
          return item;
        });
      } else {
        this.model.show_classes = null;
      }
    },
    getListUser(name = '') {
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getStaffList(params);
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getListUser(name);
      }, 500);
    },
    setSeller(user) {
      this.model.created_by = user.id;
    },
    setAutocompleteSeller(createdUser) {
      if (this.$refs.autocomplete_seller && createdUser) {
        this.$refs.autocomplete_seller.$refs.input.value = createdUser.name;
      }
    },
    showText(item) {
      return `${item.name} <strong class="document">${item.email}</strong>`;
    },
  },
  mounted() {
    const { quotation } = this.$store.state.quotation;
    this.loadModel(quotation);
    Events.$on(_LOAD_MODEL_, model => {
      this.loadModel(model);
    });
    this.checkAdmin();
    this.getCompanies();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}

</style>
<style lang="scss">
@import '~_scss/overrides';

.input-group.is-invalid {
  .input-group-prepend {
    .input-group-text {
      color: $red;
      border-color: $red;
    }
  }
}

.document {
  margin-left: 10px;
  font-weight: bold;
}

.modal-content__control {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
